if (!customElements.get('ec-product-gallery')) {
  customElements.define(
    'ec-product-gallery',
    class EcProductGallery extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
        this.dots = [...this.querySelectorAll('[data-gallery-dot]')];
        this.index = 0;
        this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.goTo(this.index - 1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
        this.viewport?.addEventListener('scroll', () => {
          window.requestAnimationFrame(() => {
            const width = this.viewport.clientWidth;
            if (!width) return;
            this.setActive(Math.round(this.viewport.scrollLeft / width));
          });
        });
      }

      goTo(index) {
        if (!this.slides.length) return;
        this.viewport.scrollTo({ left: ((index + this.slides.length) % this.slides.length) * this.viewport.clientWidth, behavior: 'smooth' });
      }

      setActive(index) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      }
    }
  );
}

if (!customElements.get('education-cards-product')) {
  customElements.define(
    'education-cards-product',
    class EducationCardsProduct extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.variantInput = this.form?.querySelector('[name="id"]');
        this.variantButtons = [...this.querySelectorAll('[data-variant-choice]')];
        this.addLabel = this.querySelector('[data-add-label]');
        this.context = this.querySelector('[data-variant-context]');
        this.gallery = this.querySelector('ec-product-gallery');
        this.variants = this.getVariants();

        this.variantButtons.forEach((button) => button.addEventListener('click', () => this.selectVariant(button)));
      }

      getVariants() {
        try {
          return JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
        } catch {
          return [];
        }
      }

      selectVariant(button) {
        if (button.disabled || !this.variantInput) return;
        const variant = this.variants.find((item) => String(item.id) === button.dataset.variantId);
        this.variantInput.value = button.dataset.variantId;
        this.variantInput.disabled = button.dataset.available !== 'true';
        this.variantButtons.forEach((choice) => {
          const active = choice === button;
          choice.classList.toggle('is-selected', active);
          choice.setAttribute('aria-pressed', String(active));
        });

        const submit = this.querySelector('[type="submit"]');
        const available = button.dataset.available === 'true';
        submit?.toggleAttribute('disabled', !available);
        if (this.addLabel) this.addLabel.textContent = available ? 'Додати до кошика' : 'Немає в наявності';
        if (this.context) {
          this.context.textContent = Number(button.dataset.unitCount) > 1
            ? `${button.querySelector('.ec-pdp__variant-top strong')?.textContent || '10 шт'} — десять брелоків цієї моделі.`
            : 'Обирайте один брелок для себе або як маленький подарунок.';
        }
        if (variant?.featured_media_id && this.gallery) {
          const mediaIndex = [...this.gallery.querySelectorAll('[data-gallery-slide]')].findIndex((slide) => String(slide.dataset.mediaId) === String(variant.featured_media_id));
          if (mediaIndex >= 0) this.gallery.goTo(mediaIndex);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', button.dataset.variantId);
        window.history.replaceState({}, '', url);
      }
    }
  );
}
